exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-yellow[data-v-6c33e054]{background-color:#f1cb5b;color:#8d6d0c}", ""]);

// exports
